import { render, staticRenderFns } from "./SetUpMyInfo.vue?vue&type=template&id=392b9e3b&"
import script from "./SetUpMyInfo.vue?vue&type=script&lang=js&"
export * from "./SetUpMyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports